////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { useSelector, shallowEqual } from 'react-redux'
import convertHexToRGBA from '../../../helpers/HexToRgba'

//////STYLED//////
const ScheduledPromoManagerStatusWrapper = styled.div`
	text-align: center;
	background-color: ${(props) => convertHexToRGBA(props.colorCode, 0.2)};
	color: ${(props) => props.colorCode};
	line-height: 32px;
	font-weight: bold;
	width: fit-content;
	padding: 0 10px;
	border-radius: 15px;
	margin: 0 auto;
`
//////STYLED//////

const ScheduledPromoManagerStatus = (props) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<ScheduledPromoManagerStatusWrapper colorCode={props.row.promotionStatus.colorCode}>
			{translations[props.row.promotionStatus.translationKey]}
		</ScheduledPromoManagerStatusWrapper>
	)
}

ScheduledPromoManagerStatus.propTypes = {}

ScheduledPromoManagerStatus.defaultPropTypes = {}

export default ScheduledPromoManagerStatus
